<template>

    <div>

        <div class="table">
            <tr>
                <td>Equity capture</td>
                <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalUnrealizedCapitalGain | currency(0) }}</td>
            </tr>
            <tr>
                <td>Annual cash flow</td>
                <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalAnnualCashFlow | currency(0) }}</td>
            </tr>
            <tr>
                <td>Return on equity capture</td>
                <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalReturnOnCapitalGainPercent | percent(0) }}</td>
            </tr>
            <tr>
                <td>Cash on cash return</td>
                <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalCashOnCashReturnPercent | percent(1) }}</td>
            </tr>
        </div>

    </div>

</template>

<script>
import store from "@/store";

export default {
  components: {
    store
  }
};
</script>
